import { AlternateEventTypeGroupMapBM } from '../types/BusinessModel/AlternateEventTypeGroupMapBM';
import { AlternateEventTypeGroupMap } from '../types/ViewModel/AlternateEventTypeGroupMap';

export default () => {
    const newAlternativeEventtypeGroupMapArray = (altEvTypeGrMapArrBM: AlternateEventTypeGroupMapBM[]): AlternateEventTypeGroupMap[] => {
        const altEvTypeGrMapArr: AlternateEventTypeGroupMap[] = [];
        if (altEvTypeGrMapArrBM && altEvTypeGrMapArrBM.length > 0) {
            altEvTypeGrMapArrBM.forEach((item) => {
                altEvTypeGrMapArr.push(newAlternativeEventtypeGroupMap(item));
            });
        }

        altEvTypeGrMapArr.push(newAlternativeEventtypeGroupMap2(1, 70, 68));
        altEvTypeGrMapArr.push(newAlternativeEventtypeGroupMap2(1, 71, 69));
        altEvTypeGrMapArr.push(newAlternativeEventtypeGroupMap2(1, 73, 72));

        return altEvTypeGrMapArr;
    };

    const newAlternativeEventtypeGroupMap = (altEvTypeGrMapBM: AlternateEventTypeGroupMapBM): AlternateEventTypeGroupMap => {
        return new AlternateEventTypeGroupMap(
            altEvTypeGrMapBM.alternateEventTypeGroupMapIdentity,
            altEvTypeGrMapBM.eventTypeGroupId,
            altEvTypeGrMapBM.initialExcludeEventTypeGroupId
        );
    };

    const newAlternativeEventtypeGroupMap2 = (
        alternateEventTypeGroupMapIdentity: number,
        eventTypeGroupId: number,
        initialExcludeEventTypeGroupId: number | null
    ): AlternateEventTypeGroupMap => {
        return new AlternateEventTypeGroupMap(alternateEventTypeGroupMapIdentity, eventTypeGroupId, initialExcludeEventTypeGroupId);
    };

    return {
        newAlternativeEventtypeGroupMapArray,
        newAlternativeEventtypeGroupMap,
    };
};
